import type { IStatusMap } from '../interfaces'

import { setColor } from '../API/loginApi'

export const checkStatus = (status: string, map: IStatusMap) => {
  const color: string[] = []
  for (const key in map) {
    const value = map[key]
    if (value && value.includes(Number(status))) {
      color.push(key)
    }
  }
  return setColor(color[0] || '')
}
